<div class="flex">
  <app-input-file-btn [owner]="owner" [replaceByOwner]="true" (uploaded)="emitUploaded($event)">
    <div [ngClass]="{'logo-block': true, 'logoBlock_border': !imageUrl, 'flex': true, 'justify-content-center': true}">
      @if (imageUrl) {
        <img
          src="{{ imageUrl }}"
          alt="logo"
          class="m-auto w-full h-full"
          style="object-fit: cover;"
          />
      }
    </div>
  </app-input-file-btn>
</div>
